<script setup>
import {onMounted, ref} from "vue";
import {useGroupCallsStore} from "@/stores/groupCallsStore";
// import {useICPStore} from "@/stores/icpStore";
// import {useAuthStore} from "@/stores/authStores";
// import api from "@/services/api";

const groupsStore = useGroupCallsStore();
//const ICP = useICPStore().ICP;
const currTab = ref('call');

onMounted(() => {
  groupsStore.initializeGroups();
});

function colorRowItem(item) {
  const isSelected = groupsStore.selectedCall.some((isdn) => isdn === item.item.isdn);
  if (isSelected && item.item.emergency) return {class: 'selected-and-row-emergency'};
  if (isSelected) return {class: 'selected'};
  if (item.item.emergency) return {class: 'row-emergency row'};
  return {class: 'row'};
}

function handleRowSelection(event, {internalItem}) {
  // Rendi la riga con nome "t2t-group" non selezionabile
  if (internalItem.value.isdn === groupsStore.t2tGroupIsdn || internalItem.value.isdn === groupsStore.patchGroupIsdn) return;
  const isCtrl = event.ctrlKey;
  const isdn = internalItem.value.isdn;
  let currentSelection = [...groupsStore.selectedCall];

  const alreadySelected = currentSelection.includes(isdn);

  if (alreadySelected) {
    if (isCtrl) {
      currentSelection = currentSelection.filter(i => i !== isdn);
    } else {
      currentSelection = currentSelection.length > 1 ? [isdn] : [];
    }
  } else {
    if (isCtrl) {
      currentSelection.push(isdn);
    } else {
      currentSelection = [isdn];

    }
  }

  groupsStore.setSelectedCall(currentSelection);
}

const headersCall = [
  {title: 'Group ID', key: 'groupId', headerProps: {style: 'font-weight: bold'}},
  {title: 'Status', key: 'status', headerProps: {style: 'font-weight: bold'}},
  {title: 'Operator', key: 'operator', headerProps: {style: 'font-weight: bold'}},
  {title: 'Time', key: 'time', sortable: true, headerProps: {style: 'font-weight: bold'}, value: item => item.time === "-" ? item.time : new Date(item.time).toLocaleDateString() + " " + new Date(item.time).toLocaleTimeString()},
  {title: 'Emergency', key: 'emergency', sortable: true, headerProps: {style: 'font-weight: bold', 'max-width': '10px'}},
  {title: 'Volume', key: 'volume', sortable: true, headerProps: {style: 'font-weight: bold'}},
];

const headersHistCall = [
  {title: 'Group ID', key: 'groupId', headerProps: {style: 'font-weight: bold'}},
  {title: 'Operator', key: 'operator', headerProps: {style: 'font-weight: bold'}},
  {title: 'Time', key: 'time', sortable: true, headerProps: {style: 'font-weight: bold'}, value: item => item.time === "-" ? item.time : new Date(item.time).toLocaleDateString() + " " + new Date(item.time).toLocaleTimeString()},
  {title: 'Type', key: 'type', sortable: true, headerProps: {style: 'font-weight: bold'}},
];
</script>


<template>
  <v-card class="h-50" style="height: 100px;">
    <v-tabs
        v-model="currTab"
        bg-color="grey"
        class="border-t"
        height="30px"
    >
      <v-tab value="call">Group Call</v-tab>
      <v-tab value="callHistory">Historic Group Call</v-tab>
    </v-tabs>
    <v-card-text class="pa-0 h-100">
      <v-tabs-window v-model="currTab" style="height: 100%;">
        <v-tabs-window-item style="height: 100%;" value="call">
          <div style="height: calc(100% - 30px); overflow-y: auto;">
            <v-data-table
                :headers="headersCall"
                :items="groupsStore.calls"
                :items-per-page="-1"
                :row-props="colorRowItem"
                clickable-rows
                density="compact"
                fixed-header
                hide-default-footer
                item-value="item.item"
                return-object
                style="height: 100%;"
                @click:row="(event, { internalItem }) => handleRowSelection(event, { internalItem })"
            >
              <template v-slot:[`item.emergency`]="{ item }">
    <span style="display: inline-block; width: 40px; max-height: 36px">
      <v-checkbox-btn
          v-model="item.emergency"
          :ripple="false"
          @click.stop
      ></v-checkbox-btn>
    </span>
              </template>
            </v-data-table>
          </div>
        </v-tabs-window-item>

        <v-tabs-window-item style="height: 100%;" value="callHistory">
          <div style="height: calc(100% - 30px); overflow-y: auto;">

            <v-data-table
                :headers="headersHistCall"
                :items=groupsStore.callHistory
                :items-per-page="-1"
                clickable-rows
                density="compact"
                fixed-header
                hide-default-footer
                item-value="operatorId"
                select-strategy="single"
                style="height: 100%;"
            >
            </v-data-table>
          </div>
        </v-tabs-window-item>

      </v-tabs-window>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.v-card {
  border-radius: 0%;
}

:deep(.row-emergency) {
  background-color: #EE5A5AFF;
  color: white;
}

:deep(.row:hover) {
  background-color: #E0E0E0;
}

:deep(.row-emergency:hover) {
  background-color: #933030;
  color: white;
}

:deep(.selected) {
  background-color: #3f3f3f;
  color: white;
}

:deep(.selected-and-row-emergency) {
  background-color: #8e0404;
  color: white;
}
</style>
